import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import VideoChat from '../../components/messaging/videoChat/VideoChat';
import i18n from '../../config/i18n';
import WebSocketActionCreators from '../../actions/WebSocketActionCreators';
import * as ActionCreators from '../../actions/ActionCreators';
import phoneIcon from '../../styles/images/phone.svg'; // downloaded from the internet, change later for commercial use
import '../../styles/css/videoChat.css';
import ChannelAPIConnectors from '../../api/ChannelAPIConnectors';

const styles = {
  button: {
    height: 45,
    width: 45,
    position: 'absolute',
    right: '30px',
    borderRadius: '50%',
    border: '2px solid white',
    background: 'red',
    zIndex: 1,
  },
  addIcon: {
    height: '25px',
    width: '25px',
    paddingLeft: '3.5px',
  },
  image: {
    width: 300,
    height: 300,
  },
  mainPlayer: {
    margin: 'auto',
    display: 'block',
  },
};

// how to get webcam natively in chrome:
// navigator.webkitGetUserMedia({video: true}, (e)=>console.log(e), (e)=>console.log('2', e))

class VideoChatContainer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      createDangerAlert: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    apiKey: null,
    sessionId: null,
    token: null,
    createdAt: null,
    endedAt: null,
    isMobile: window.innerWidth < 480,
  };

  componentDidMount() {
    const {
      actions: {
        createAlert,
        websocketConnect,
      },
      currentChannelId,
    } = this.props;

    websocketConnect();

    ChannelAPIConnectors.getVideoChatSessionInfo(parseInt(currentChannelId, 10))
      .then((response) => {
        this.setState({
          apiKey: response.tokBoxApiKey,
          sessionId: response.sessionId,
          token: response.token,
          createdAt: response.createdAt,
          endedAt: response.endedAt,
        });
      })
      .catch(e => createAlert(e));
  }

  componentWillUnmount() {
    this.props.actions.websocketDisconnect();
  }

  handleButtonClick = () => {
    window.history.back();
  };

  render() {
    const { actions } = this.props;
    const {
      apiKey,
      sessionId,
      token,
      createdAt,
      endedAt,
      isMobile,
    } = this.state;
    return (
      <div>
        <div>
          <button
            style={styles.button}
            onClick={this.handleButtonClick}
          >
            <img
              style={styles.addIcon}
              className="svg-icon"
              alt={i18n.t('add')}
              src={phoneIcon}
            />
          </button>
        </div>
        <div style={styles.mainPlayer}>
          {
            apiKey && sessionId && token
              ? <VideoChat
                apiKey={apiKey}
                sessionId={sessionId}
                token={token}
                loadingDelegate={<div>Loading...</div>}
                opentokClientUrl="https://static.opentok.com/v2/js/opentok.min.js"
                actions={actions}
                createdAt={createdAt}
                endedAt={endedAt}
                isMobile={isMobile}
              />
              : null
          }
        </div>
      </div >
    );
  }
}

// eslint-disable-next-line
const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => {
  const myActions = {
    ...WebSocketActionCreators,
    ...ActionCreators,
  };
  return {
    actions: bindActionCreators(myActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoChatContainer);



// WEBPACK FOOTER //
// ./src/containers/messaging/VideoChatContainer.js